import React from 'react'
import {
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    Dialog,
    DialogTrigger,
  } from "@/components/ui/dialog";

export default function DialogModal({trigger, children, title}) {
  return (
    <div>
        <Dialog>
                <DialogTrigger className=" ">
                  {" "}
                  {trigger}
                </DialogTrigger>
                <DialogContent>
                  <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription className="pt-5">
                      {children}
                    </DialogDescription>
                  </DialogHeader>
                </DialogContent>
              </Dialog>
    </div>
  )
}
